/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

export default angular.module('tektelic.api.gatewayCommand', [])
    .factory('gatewayCommandService', GatewayCommandService)
    .name;

/*@ngInject*/
function GatewayCommandService($http, $q) {

    var service = {
        executeCommand: executeCommand
    };

    function executeCommand(gatewayId, command, params, ignoreLoading) {
        var deferred = $q.defer();
        var url = `/api/gateway/${gatewayId}/command/${command}`;
        $http.post(url, params, {ignoreErrors: true, ignoreLoading: ignoreLoading}).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail(rejection) {
            deferred.reject(rejection);
        });
        return deferred.promise;
    }

    return service;
}


// WEBPACK FOOTER //
// ./src/app/api/gateway-command.service.js